var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import useEmotionStyles from '../../hooks/useEmotionStyles';
var styles = function (theme) {
    var _a;
    return ({
        root: {
            '& .MuiPaper-root': (_a = {},
                _a[theme.breakpoints.down('sm')] = {
                    width: '100%',
                    marginLeft: '16px',
                    marginRight: '16px',
                },
                _a),
        },
        actions: {
            marginTop: "-".concat(theme.spacing(1)),
        },
    });
};
var Modal = function (_a) {
    var open = _a.open, title = _a.title, _b = _a.actions, actions = _b === void 0 ? [] : _b, _c = _a.onClose, onClose = _c === void 0 ? Function : _c, _d = _a.closeByEsc, closeByEsc = _d === void 0 ? false : _d, _e = _a.closeByBackdropClick, closeByBackdropClick = _e === void 0 ? false : _e, children = _a.children;
    var cs = useEmotionStyles(styles);
    var handleDialogClose = useCallback(function (ev, reason) {
        if (reason === 'escapeKeyDown' && !closeByEsc) {
            return;
        }
        if (reason === 'backdropClick' && !closeByBackdropClick) {
            return;
        }
        onClose && onClose();
    }, [onClose, closeByEsc, closeByBackdropClick]);
    return (React.createElement(Dialog, { open: open, onClose: handleDialogClose, fullWidth: true, className: cs.root },
        title && React.createElement(DialogTitle, null, title),
        React.createElement(DialogContent, null, children),
        actions.length > 0 && (React.createElement(DialogActions, { className: cs.actions }, actions.map(function (_a) {
            var btnTitle = _a.title, restProps = __rest(_a, ["title"]);
            var btnProps = restProps;
            return (React.createElement(Button, __assign({ key: btnTitle }, btnProps), btnTitle));
        })))));
};
export default Modal;
